document.addEventListener("DOMContentLoaded", function () {

  $('.prd_zoom_slider--image_list--slick').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true
  });


  window.addEventListener("facetUpdated", function () {
    setTimeout(() => {
      collectionSlider()
    }, 500);
  })

  function collectionSlider() {
    $('.slider_images_prd').slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 100,
    });

    // // Initialize the slider
    // $('.facet_slider').slick({
    //   dots: false,
    //   infinite: false,
    //   arrows: false,
    //   speed: 300,
    //   slidesToShow: 8,
    //   slidesToScroll: 2,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: 'unslick'
    //     }
    //   ]
    // });

    // function checkScreenSize() {
    //   if (window.matchMedia('(max-width: 1024px)').matches) {
    //     if ($('.facet_slider').hasClass('slick-initialized')) {
    //       $('.facet_slider').slick('unslick');
    //     }
    //   }
    // }

    // checkScreenSize();

    // $(window).on('resize', function() {
    //   checkScreenSize();
    // });
  }
  
  // collectionSlider()
   setTimeout(() => {
      collectionSlider()
    }, 2000);

  document.querySelectorAll(".custom_prd_variant .swatch_input_value .swatch-input__label")?.forEach(function (elemt) {
    elemt.addEventListener("click", function () {
      const variantImg = this.dataset.variantImg;
      const variantSrc = this.dataset.variantUrl;
      this.closest(".product_card_wrapper").querySelector(".prd_images_conatiner .slick-slide.slick-current.slick-active img").src = variantImg;
      this.closest(".product_card_wrapper").querySelector(".prd_images_conatiner .slick-slide.slick-current.slick-active a").href = variantSrc;
    })    
  })

  function getSetHeight() {
    const prdImagesContainer = document.querySelector(".prd_images_conatiner");
    const collectionWrapper = document.querySelector(".collection_prd_grid");
    
    if (prdImagesContainer && collectionWrapper) {
      const prdCardHeight = prdImagesContainer.getBoundingClientRect().height;
      collectionWrapper.style.setProperty('--prd-height', `${prdCardHeight}px`);
    }
  }

  window.addEventListener("resize", function () {
    getSetHeight();
  })

  let resizeTimeout;
  function debounceResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(getSetHeight, 100);
  }

  window.addEventListener('resize', debounceResize);
  getSetHeight();

  // Cart Discount Code Functionality
  function applyDiscountCode(item) {  
    let discountCode = item.closest('.cart_promo_code').querySelector('input').value;
    // const discountCode = document.getElementById('discount-code').value;
    console.log(discountCode);
    
    if (discountCode) {
      fetch('/discount/' + discountCode)
        .then(response => {
          if (response.ok) {

            if(!window.location.pathname.includes('/cart')){ window.dispatchEvent(new CustomEvent('discountEvt')); }

            if(window.location.pathname.includes('/cart')){
              let discount_succ_text = item.closest('.cart_promo_code').querySelector('.discount--success-text');
              discount_succ_text.classList.add('discount--success-text--active');
              setTimeout( ()=> { discount_succ_text.classList.remove('discount--success-text--active') }, 1000)
            }
            console.log('Discount code applied successfully');
            
          } else {
            alert('Discount code not valid');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          alert('An error occurred while applying the discount');
        });
    } else {
      alert('Please enter a discount code');
    }
  }

  document.addEventListener('click', function(e) {
    if (e.target.matches('.apply-discount-button')) {
      e.preventDefault();
      applyDiscountCode(e.target);
    }
  });

  // document.querySelectorAll(`.product-form__input input[type="radio"]`).forEach(function (ele) {
  //   ele.addEventListener("change", function () {
  //     console.log(this);
  //   })
  // })

})

function updateWhatsInsideFromVariant() {
  const id = new URLSearchParams(location.search).get('variant');
  const input = id 
    ? document.getElementById(`take-data-${id}`) 
    : document.querySelector('.data-provider-input');

  const target = document.querySelector('.whats_inside');
  const target2 = document.querySelector('.collapsible_description');

  const imgSrc = document.querySelector('.qwa-container .qwa-image img')
  const updatePrice = document.querySelector('.qwa-variant-price p')

  if (input) {
    if (target) target.innerHTML = `<p>${input.value}</p>`;
    if (target2) target2.innerHTML = `<p>${input.dataset.variantDescription}</p>`;
    if (imgSrc) imgSrc.src = input.dataset.variantImg;
    if (updatePrice) updatePrice.innerText = input.dataset.variantPrice;
  }
  const atcParagraph = document.querySelector('.tpa-container .tpa-atc p');
  const atcBtn = document.querySelector('.qwa-container .tpa-atc .product-form__buttons span')?.innerText;
  if(atcParagraph){
    atcParagraph.innerText = atcBtn;
    atcParagraph.style.pointerEvents = atcBtn === 'Unavailable' ? 'none' : '';
    atcParagraph.style.backgroundColor = atcBtn === 'Unavailable' ? '#888888' : '#000';
  }
  
}

document.addEventListener('DOMContentLoaded', () => {
  updateWhatsInsideFromVariant();
  document.addEventListener('change', e =>
    e.target.closest('variant-selects') && setTimeout(updateWhatsInsideFromVariant, 1000)
  );
});

document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector(".qwa-container");

  if (!productForm) return;

  let isSticky = false;

  function updateStickyClass() {
    // const shouldApplySticky = window.scrollY > 470 && window.innerWidth <= 749;
    const shouldApplySticky = ((window.scrollY > 470 && window.innerWidth <= 749) || (window.scrollY > 470 && window.innerWidth > 749));


    if (shouldApplySticky && !isSticky) {
      productForm.classList.add("sticy_moble");
      isSticky = true;
    } else if (!shouldApplySticky && isSticky) {
      productForm.classList.remove("sticy_moble");
      isSticky = false;
    }
  }

  window.addEventListener("scroll", updateStickyClass);
  window.addEventListener("resize", updateStickyClass);

  const container = document.querySelector('.qwa-container');
  if (!container) return;

  const input = container.querySelector('input.quantity__input');
  const label = container.querySelector('.price-per-item__container p');
  const buttons = container.querySelectorAll('.quantity__button');

  const updateLabel = () => label.textContent = +input.value === 1 ? 'Pack' : 'Packs';

  input.addEventListener('input', updateLabel);
  buttons.forEach(btn => btn.addEventListener('click', () => setTimeout(updateLabel, 50)));

  updateLabel();

  // document.querySelectorAll('.tpa-2nd .tpa-atc p').forEach(function(atcBtn) {
  //   atcBtn.addEventListener('click', function () {
  //     this.innerText = 'Adding...';

  //     // Click the single product form button
  //     const productFormButton = document.querySelector('product-form button');

  //     if (productFormButton) {
  //       productFormButton.click();
  //     }

  //     setTimeout(() => {
  //       this.innerText = 'Add to cart';
  //     }, 2000);
  //   });
  // });


});
// document.addEventListener('DOMContentLoaded', () => {
//   const scrollSpeed = 200;
//   let initialized = false;

//   const getContainer = () => document.querySelector('.ctm_facet_main_wrapper .facets__list');
//   const getLeftBtn = () => document.querySelector('.facet-scroll-left');
//   const getRightBtn = () => document.querySelector('.facet-scroll-right');

//   function updateButtonVisibility(container, leftBtn, rightBtn) {
//     const maxScrollLeft = container.scrollWidth - container.clientWidth;
//     leftBtn.style.display = container.scrollLeft > 0 ? 'block' : 'none';
//     rightBtn.style.display = container.scrollLeft < maxScrollLeft ? 'block' : 'none';
//   }

//   function disableAllUserScroll(container) {
//     container.addEventListener('wheel', e => e.preventDefault(), { passive: false });
//     container.addEventListener('touchmove', e => e.preventDefault(), { passive: false });
//     container.addEventListener('keydown', e => {
//       if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
//         e.preventDefault();
//       }
//     });
//     container.style.overflow = 'hidden';
//   }

//   function setup() {
//     const container = getContainer();
//     const leftBtn = getLeftBtn();
//     const rightBtn = getRightBtn();

//     if (!container || !leftBtn || !rightBtn) return;

//     // Prevent re-initialization if same container
//     if (initialized === container) return;
//     initialized = container;

//     leftBtn.style.display = 'none';
//     rightBtn.style.display = 'none';

//     disableAllUserScroll(container);

//     container.addEventListener('scroll', () => {
//       updateButtonVisibility(container, leftBtn, rightBtn);
//     });

//     window.addEventListener('resize', () => {
//       updateButtonVisibility(container, leftBtn, rightBtn);
//     });

//     setTimeout(() => updateButtonVisibility(container, leftBtn, rightBtn), 100);
//   }

//   // Delegated click handling
//   document.addEventListener('click', (e) => {
//     const container = getContainer();
//     if (!container) return;

//     if (e.target.classList.contains('facet-scroll-left')) {
//       container.scrollBy({ left: -scrollSpeed, behavior: 'smooth' });
//       setTimeout(() => updateButtonVisibility(container, getLeftBtn(), getRightBtn()), 300);
//     }

//     if (e.target.classList.contains('facet-scroll-right')) {
//       container.scrollBy({ left: scrollSpeed, behavior: 'smooth' });
//       setTimeout(() => updateButtonVisibility(container, getLeftBtn(), getRightBtn()), 300);
//     }
//   });

//   // Observe dynamic content refreshes
//   const wrapper = document.querySelector('.ctm_facet_main_wrapper') || document.body;

//   const observer = new MutationObserver(() => {
//     requestAnimationFrame(setup);
//   });

//   observer.observe(wrapper, {
//     childList: true,
//     subtree: true
//   });

//   // Initial run
//   setup();
// });

















// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('media-gallery .product__media img').forEach((mediaImg) => {
//     mediaImg.addEventListener('click', function() {
//       const mediaGallery = document.querySelector('media-gallery');
//       if (mediaGallery) {
//         mediaGallery.style.position = 'fixed';
//         mediaGallery.style.top = '0';
//         mediaGallery.style.bottom = '0';
//         mediaGallery.style.right = '0';
//         mediaGallery.style.left = '0';
//         mediaGallery.style.zIndex = '4';
//         mediaGallery.style.display = 'flex';
//         mediaGallery.style.alignItems = 'center';
//         mediaGallery.style.justifyContent = 'center';
//         mediaGallery.style.background = '#f4eae4';
//       }
//     });
//   });
// });







// document.addEventListener('DOMContentLoaded', () => {
//     // Step 1: Get the list of valid image sources from 'li.product__media-item'
//     const validImageSrcs = [];
//     const liElements = document.querySelectorAll('li.product__media-item');

//     liElements.forEach((li) => {
//         const img = li.querySelector('img');
//         if (img) {
//             // Normalize the src (remove query parameters) for comparison
//             const srcWithoutParams = img.src.split('?')[0];
//             validImageSrcs.push(srcWithoutParams); // Store the cleaned src
//             console.log('Valid image src:', srcWithoutParams); // Optionally log the image src
//         }
//     });

//     // Step 2: Select all images in the slider and log those whose src is not in validImageSrcs
//     const images = document.querySelectorAll('.prd_zoom_slider--image_list img');

//     images.forEach((img) => {
//         const imgSrcWithoutParams = img.src.split('?')[0]; // Clean the src (remove query parameters)
        
//         if (!validImageSrcs.includes(imgSrcWithoutParams)) {
//             console.log('Image src not in valid list:', imgSrcWithoutParams); // Log the src that is not valid
//         }
//     });
// });

// document.addEventListener('DOMContentLoaded', () => {
//     // Step 1: Get the list of valid image sources from 'li.product__media-item'
//     const validImageSrcs = [];
//     const liElements = document.querySelectorAll('li.product__media-item');

//     liElements.forEach((li) => {
//         const img = li.querySelector('img');
//         if (img) {
//             // Normalize the src (remove query parameters) for comparison
//             const srcWithoutParams = img.src.split('?')[0];
//             validImageSrcs.push(srcWithoutParams); // Store the cleaned src
//             console.log('Valid image src:', srcWithoutParams); // Optionally log the image src
//         }
//     });

//     // Step 2: Select all images in the slider and hide those whose src is not in validImageSrcs
//     const images = document.querySelectorAll('.prd_zoom_slider--image_list img');

//     images.forEach((img) => {
//         const imgSrcWithoutParams = img.src.split('?')[0]; // Clean the src (remove query parameters)
        
//         if (!validImageSrcs.includes(imgSrcWithoutParams)) {
//             // If the image src is not valid, hide the parent .slick-slide
//             const slickSlide = img.closest('.slick-slide');
//             if (slickSlide) {
//                 slickSlide.style.display = 'none'; // Hide the .slick-slide element
//             }
//         }
//     });
// });